import { firstValueFrom } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export default class GetSanitizedImageUrlUtil {
  protected userService = inject(UserService);
  protected sanitizer = inject(DomSanitizer);

  async getSanizedImageUrlByUserId(userId: string) {
    const imageBlob = await firstValueFrom(this.userService.getUserImageById(userId));
    const safeUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(imageBlob as unknown as Blob));
    return safeUrl;
  }
}
